export default __webpack_public_path__ + "static/media/beveled-cone.ed9bbfe3.png";